import axios from 'axios'
import Vue from 'vue'
import VueAuth from '@optix/vue-auth'

Vue.use(VueAuth)

let $axios = axios.create({
  baseURL: '/api/',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
})

// Request Interceptor
$axios.interceptors.request.use(config => {
  config.headers['Authorization'] = 'JWT ' + Vue.auth.token()
  return config
})

// Response Interceptor to handle errors
$axios.interceptors.response.use(
  response => response,
  error => {
    let message = ''

    if (error.response) {
      let code = error.response.status
      if (code === 500) {
        message = error.response.data.message || 'Ошибка сервера. Попробуйте обновить страницу.'
      } else if (code === 401) {
        message = 'Ошибка авторизации. Попробуйте заново ввести логин/пароль.'
      } else {
        message = error.response.data.message || 'Неизвестная ошибка.'
      }
    } else {
      message = 'Не поступил ответ от сервера.'
    }

    Vue.swal({ type: 'error', text: message })

    return Promise.reject(error)
  })

export default {

  fetchData (url, params = {}) {
    return $axios.get(url, { params })
      .then(response => response.data)
  },

  postData (url, data) {
    return $axios.post(url, data)
      .then(response => response.data)
  },

  login (agentId, password) {
    return $axios.post(`auth`, { agentId, password })
      .then(response => {
        Vue.auth.setToken(response.data.access_token)
        return response.data.access_token
      })
  }
}
